import { gql, useLazyQuery } from "@apollo/client";
import { AsyncQueryStatus } from "../../models/AsyncActionStatus";
import { getErrors } from "../../utils";
import { CORE_PROJECT_FIELDS } from "../fragments/project";
import { GetProject, GetProjectVariables } from "./__generated__/GetProject";

export const GET_PROJECT = gql`
  ${CORE_PROJECT_FIELDS}
  query GetProject($id: String!) {
    project(id: $id) {
      ...CoreProjectFields
      maxProjectAssignments
      standardLicenceAssignmentCount
      boundaries {
        coordinates
        crs
        type
      }
    }
  }
`;

export function useLazyGetProject() {
  const [getProject, { loading, error, data }] = useLazyQuery<GetProject, GetProjectVariables>(GET_PROJECT, {
    fetchPolicy: "cache-and-network",
    errorPolicy: "all",
  });

  return {
    getProject,
    data,
    status: {
      loading,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncQueryStatus,
  };
}
